import ActionTypes from '../constants/ActionTypes';

/* Events */

export const createDeviceLabelRequested = (data) => ({
  type: ActionTypes.DEVICE_LABEL_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createDeviceLabelSucceeded = (deviceLabel) => ({
  type: ActionTypes.DEVICE_LABEL_CREATE_SUCCEEDED,
  payload: {
    deviceLabel,
  },
});

export const createDeviceLabelFailed = (error) => ({
  type: ActionTypes.DEVICE_LABEL_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createDeviceLabelReceived = (deviceLabel) => ({
  type: ActionTypes.DEVICE_LABEL_CREATE_RECEIVED,
  payload: {
    deviceLabel,
  },
});

export const deleteDeviceLabelRequested = (deviceId, labelId) => ({
  type: ActionTypes.DEVICE_LABEL_DELETE_REQUESTED,
  payload: {
    deviceId,
    labelId,
  },
});

export const deleteDeviceLabelSucceeded = (deviceLabel) => ({
  type: ActionTypes.DEVICE_LABEL_DELETE_SUCCEEDED,
  payload: {
    deviceLabel,
  },
});

export const deleteDeviceLabelFailed = (deviceId, labelId, error) => ({
  type: ActionTypes.DEVICE_LABEL_DELETE_FAILED,
  payload: {
    deviceId,
    labelId,
    error,
  },
});

export const deleteDeviceLabelReceived = (deviceLabel) => ({
  type: ActionTypes.DEVICE_LABEL_DELETE_RECEIVED,
  payload: {
    deviceLabel,
  },
});
